// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 5839 ? "standalone-dialog" : chunkId) + "." + {"2116":"5a176621","3773":"ee7f8adc","5839":"4184c41f"}[chunkId] + ".js";
};